import {ReduxAction} from "../../models/common/ActionTypes";
import {FileData} from "../../models/common/FileData";
import {catchError, map, Observable, of} from "rxjs";
import {ofType, StateObservable} from "redux-observable";
import {AppState} from "../../reducers/RootReducer";
import {APP_CONFIG} from "../../config/GeneralConfig";
import {ajax} from "rxjs/ajax";
import {mergeMap} from "rxjs/operators";
import {base64ToArrayBuffer, downloadFileHelper} from "../../helpers/FileHelpers";


export interface DownloadFileAction extends ReduxAction<typeof DOWNLOAD_FILE_ACTION> {
    uri: string
    fileData: FileData
}

export const DOWNLOAD_FILE_ACTION = "DOWNLOAD_FILE_ACTION";
export const DOWNLOAD_FILE_ACTION_SUCCESS = "DOWNLOAD_FILE_ACTION_SUCCESS";
export const DOWNLOAD_FILE_ACTION_ERROR = "DOWNLOAD_FILE_ACTION_ERROR";

export function downloadFile( fileData: FileData, uri: string ): DownloadFileAction {
    return {
        type: DOWNLOAD_FILE_ACTION,
        fileData,
        uri
    };
}

export function downloadFileSuccess(payload: Blob, fileData: FileData ) {
    return { type: DOWNLOAD_FILE_ACTION_SUCCESS, data: payload, fileData };
}

export function downloadFileError( error: any ) {
    return { type: DOWNLOAD_FILE_ACTION_ERROR, error };
}

export function downloadFileEpic(
    action$: Observable< DownloadFileAction >,
    store$: StateObservable< AppState >
) {
    return action$.pipe(
        ofType( DOWNLOAD_FILE_ACTION ),
        //@ts-ignore
        mergeMap( action => {
            //@ts-ignore
            const url = APP_CONFIG.baseWeb + action.uri;

            //@ts-ignore
            return ajax({
                ...APP_CONFIG.getRequestObject( url ),
                responseType: "blob",
                async: false
            }).pipe(
                map( response => {

                    //@ts-ignore
                    const blob = downloadFileHelper( response.response, action.fileData );

                    return downloadFileSuccess( blob, action.fileData  )
                }),
                catchError( error => {

                    return of( downloadFileError( error )  )
                } )
            )
        } )
    )
}